import { EReportTypes } from 'entities/Report';
import { i18n } from 'i18n';
import { ICol } from 'widgets/ReportsList';

export const COLS_STORAGE_FIELD = 'reporColumns6';
const storageString = localStorage.getItem(COLS_STORAGE_FIELD);
const storageCols = storageString ? (JSON.parse(storageString) as ICol[]) : null;

const getInitialCols = (currency: string): ICol[] => [
	{
		id: 'date',
		title: i18n.t('Дата'),
		sorter: true,
		visible: true,
		groups: [EReportTypes.DATE],
	},
	{
		id: 'order_id',
		title: i18n.t('ID заявки'),
		sorter: true,
		visible: true,
		groups: [EReportTypes.ACTION],
	},
	{
		id: 'date_time',
		title: i18n.t('Дата и время'),
		sorter: true,
		visible: true,
		groups: [EReportTypes.ACTION],
	},
	{
		id: 'offer',
		title: i18n.t('Оффер'),
		sorter: true,
		visible: true,
		groups: [EReportTypes.OFFER],
	},
	{
		id: 'brand',
		title: i18n.t('Рекламодатель'),
		sorter: true,
		visible: true,
		groups: [EReportTypes.ACTION, EReportTypes.OFFER],
	},
	{
		id: 'source_offer',
		title: i18n.t('Оффер-источник'),
		sorter: true,
		sortField: 'offer',
		visible: true,
		groups: [EReportTypes.ACTION],
	},
	{
		id: 'cross_sell',
		title: i18n.t('Тип'),
		sorter: true,
		visible: true,
		groups: [EReportTypes.ACTION],
	},
	{
		id: 'click_offer',
		title: i18n.t('Оффер конверсии'),
		sorter: true,
		visible: true,
		groups: [EReportTypes.ACTION],
	},
	{
		id: 'source',
		title: i18n.t('Площадка'),
		sorter: true,
		visible: true,
		groups: [EReportTypes.ACTION, EReportTypes.SOURCE],
	},
	{
		id: 'clicks_count',
		title: i18n.t('Клики'),
		sorter: true,
		visible: true,
		groups: [EReportTypes.DATE, EReportTypes.OFFER, EReportTypes.SOURCE],
	},
	{
		id: 'cross_sell_count',
		title: i18n.t('Кросс-конверсии'),
		sorter: true,
		visible: true,
		groups: [EReportTypes.DATE, EReportTypes.OFFER, EReportTypes.SOURCE],
	},
	{
		id: 'direct_sell_count',
		title: i18n.t('Прямые конверсии'),
		sorter: true,
		visible: true,
		groups: [EReportTypes.DATE, EReportTypes.OFFER, EReportTypes.SOURCE],
	},
	{
		id: 'actions_count',
		title: i18n.t('Все конверсии'),
		sorter: true,
		visible: true,
		groups: [EReportTypes.DATE, EReportTypes.OFFER, EReportTypes.SOURCE],
	},
	{
		id: 'cr',
		title: `${i18n.t('CR')}, %`,
		sorter: false,
		minWidth: 80,
		visible: true,
		groups: [EReportTypes.DATE, EReportTypes.OFFER, EReportTypes.SOURCE],
	},
	{
		id: 'ar',
		title: `${i18n.t('AR')}, %`,
		sorter: false,
		minWidth: 80,
		visible: true,
		groups: [EReportTypes.DATE, EReportTypes.OFFER, EReportTypes.SOURCE],
	},
	{
		id: 'epc',
		title: `${i18n.t('EPC')}, ${currency}`,
		sorter: false,
		minWidth: 80,
		visible: true,
		groups: [EReportTypes.DATE, EReportTypes.OFFER, EReportTypes.SOURCE],
	},
	{
		id: 'epl',
		title: `${i18n.t('EPL')}, ${currency}`,
		sorter: false,
		minWidth: 80,
		visible: true,
		groups: [EReportTypes.DATE, EReportTypes.OFFER, EReportTypes.SOURCE],
	},
	/*{
		id: 'geo',
		title: i18n.t('Гео'),
		sorter: false,
		visible: true,
		groups: [EReportTypes.ACTION],
	},*/
	{
		id: 'title',
		title: i18n.t('Действия'),
		sorter: true,
		visible: true,
		groups: [EReportTypes.ACTION],
	},
	{
		id: 'status',
		title: i18n.t('Статус'),
		sorter: true,
		visible: true,
		groups: [EReportTypes.ACTION],
	},
	{
		id: 'approved_amount',
		title: `${i18n.t('Подтвержденная сумма')}, ${currency}`,
		sorter: true,
		visible: true,
		groups: [EReportTypes.DATE, EReportTypes.OFFER, EReportTypes.SOURCE],
	},
	{
		id: 'pending_amount',
		title: `${i18n.t('Открытый баланс')}, ${currency}`,
		sorter: true,
		visible: true,
		groups: [EReportTypes.DATE, EReportTypes.OFFER, EReportTypes.SOURCE],
	},
	{
		id: 'rejected_amount',
		title: `${i18n.t('Отклоненный баланс')}, ${currency}`,
		sorter: true,
		visible: true,
		groups: [EReportTypes.DATE, EReportTypes.OFFER, EReportTypes.SOURCE],
	},
	{
		id: 'amount',
		title: `${i18n.t('Сумма')}, ${currency}`,
		sorter: true,
		visible: true,
		groups: [EReportTypes.ACTION],
	},
	{
		id: 'cart',
		title: `${i18n.t('Сумма заказа')}, ${currency}`,
		sorter: true,
		visible: true,
		groups: [EReportTypes.ACTION],
	},
	{
		id: 'subid1',
		title: 'SubID 1',
		sorter: false,
		visible: true,
		groups: [EReportTypes.ACTION],
	},
	{
		id: 'subid2',
		title: 'SubID 2',
		sorter: false,
		visible: true,
		groups: [EReportTypes.ACTION],
	},
	{
		id: 'subid3',
		title: 'SubID 3',
		sorter: false,
		visible: true,
		groups: [EReportTypes.ACTION],
	},
	{
		id: 'ip_addr',
		title: i18n.t('IP адрес'),
		sorter: false,
		visible: true,
		groups: [EReportTypes.ACTION],
	},
];

export const getColumns = (currency: string) =>
	!storageCols
		? getInitialCols(currency)
		: getInitialCols(currency).sort((a, b) => {
				const aIndex = storageCols.findIndex((col) => col.id === a.id);
				const bIndex = storageCols.findIndex((col) => col.id === b.id);
				return aIndex - bIndex;
			});
